/**
 * Градиенты для курсов без обложки. Первые три — рекомендованные сочетания из
 * брендбука Open Academy (OA Purple + Active Orange, Soft Pink + Bright Yellow,
 * Sky Blue + Fresh Lime); остальные собраны из той же палитры («все цвета
 * можно сочетать между собой»). Цвета — часть бренда, а не темы приложения.
 */
export const COVER_GRADIENTS: readonly (readonly [string, string])[] = [
  ['#FF8645', '#A66CFF'], // Active Orange → OA Purple
  ['#FFDD31', '#FF96C8'], // Bright Yellow → Soft Pink
  ['#CCEF40', '#88C5FD'], // Fresh Lime → Sky Blue
  ['#88C5FD', '#A66CFF'], // Sky Blue → OA Purple
  ['#FF96C8', '#A66CFF'], // Soft Pink → OA Purple
  ['#FFDD31', '#FF8645'], // Bright Yellow → Active Orange
]

/**
 * Градиент курса «случайный, но устойчивый»: по номеру курса, а не по
 * `Math.random()` — иначе обложка меняла бы цвет на каждой перерисовке списка.
 */
export const coverGradientFor = (seed: number): string => {
  const index = Math.abs(Math.trunc(seed)) % COVER_GRADIENTS.length
  const [from, to] = COVER_GRADIENTS[index]
  return `linear-gradient(to bottom, ${from}, ${to})`
}
